module.exports = __webpack_public_path__ + "static/media/buy.07745d35.svg";